import { BaseModel } from "model/BaseModel";
import ItemExecucaoPlanoQualidade from "./ItemExecucaoPlanoQualidade";
import Usuario from "model/administracao/cadastro/Usuario";

export default class ExecucaoPlanoQualidade implements BaseModel{
    id: number;
    codigo: string = "";
    dataGeracao: Date;
    dataAlteracao: Date;
    usuarioAlteracao: Usuario;
    status: string;
    fase: string;
    observacao: string;
    itens: ItemExecucaoPlanoQualidade[];

    constructor(
        id: number = 0,
        dataGeracao: Date = new Date(),
        dataAlteracao: Date = new Date(),
        usuarioAlteracao: Usuario = new Usuario(),
        status: string = "",
        fase: string = "",
        observacao: string = "",
        itens: ItemExecucaoPlanoQualidade[] = []
    ) {
        this.id = id;
        this.dataGeracao = dataGeracao;
        this.dataAlteracao = dataAlteracao;
        this.usuarioAlteracao = usuarioAlteracao;
        this.status = status;
        this.fase = fase;
        this.observacao = observacao;
        this.itens = itens;
    }
}